<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="width:100% !important">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!-- page content -->
            <div class="admin-page-content">
                <!-- Forms -->
                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <!-- First Name -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">First Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="firstNameError = ''" class="form-control" id="firstName" placeholder="Enter First Name" v-model="firstName">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{firstNameError}}</span>
                            </div>
                        </div>
                        <!-- Last Name -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Last Name :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="lastNameError = ''" class="form-control" id="lastName" placeholder="Enter Last Name" v-model="lastName">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{lastNameError}}</span>
                            </div>
                        </div>
                        <!-- Email -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Email : </div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input @input="emailError = ''" class="form-control" id="email" placeholder="Enter Email" v-model="email">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{emailError}}</span>
                            </div>
                        </div>
                        <template v-if="isNonVVGDealer == 'NO'">
                            <!-- Dayforce ID -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">DayforceId: </div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input @input="dayforceIdError = ''" class="form-control" id="dayforceId" placeholder="Enter DayforceId" v-model="dayforceId">
                                    <div class="requiredstar">*</div>
                                    <span class="text-danger">{{dayforceIdError}}</span>
                                </div>
                            </div>
                        </template>
                        <!-- Role -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Role :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="roleId"
                                    name="roleId"
                                    id="roleId"
                                    label="name"
                                    :filterable="true"
                                    :options="roleOptions"
                                    @input="onChangeRole()"
                                    :clearable="false"
                                    placeholder="Select Role">
                                    <template slot="no-options">
                                        Search Role...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.name }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.name }}
                                        </div>
                                    </template>
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{roleError}}</span>
                            </div>
                        </div>
                        <template v-if="isNonVVGDealer == 'YES'">
                            <!-- Password -->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Password :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input @input="passwordError = ''" id="toggle-password" type="password" placeholder="Enter Password" class="form-control" name="password" v-model="password">
                                    <div v-show="!isEdit" class="requiredstarPassword">*</div>
                                    <span toggle="#toggle-password" class="fa fa-lg fa-eye field-icon toggle-password" style="position: absolute;top: 9px;right: 25px;cursor: pointer;z-index: 2;"></span>
                                    <span class="text-danger">{{passwordError}}</span>
                                </div>
                            </div>

                            <!--Confirm Password-->
                            <div class="col-6 forms-block">
                                <div class="col-3 paddingleft0">
                                    <div class="form-label">Confirm Password :</div>
                                </div>
                                <div class="col-9 paddingleft0">
                                    <input @input="confirmPasswordError = ''" id="toggle-password-confirm" type="password" class="form-control" name="confirmPassword" placeholder="Confirm Password" v-model="confirmPassword">
                                    <div v-show="!isEdit" class="requiredstarPassword">*</div>
                                    <span toggle="#toggle-password-confirm" class="fa fa-lg fa-eye field-icon toggle-password-confirm" style="position: absolute;top: 9px;right: 25px;cursor: pointer;z-index: 2;"></span>
                                    <span class="text-danger">{{confirmPasswordError}}</span>
                                </div>
                            </div>
                        </template>
                        <!-- Mapped List -->
                        <div v-if="isMappedListShow" class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">List :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select class="multi-select-list" v-model="mappedId"
                                    multiple
                                    name="mappedId"
                                    id="mappedId"
                                    label="text"
                                    @change="changedValue"
                                    @input="changedValueMappedList()"
                                    :filterable="false"
                                    :options="mappedArr"
                                    @search="onSearchMappedList"
                                    :placeholder="mappedPlaceholder">
                                    <template slot="no-options">
                                        {{mappedSearch}}
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                </v-select>
                                <!-- <div class="requiredstar">*</div>
                                <span class="text-danger">{{mappedIdError}}</span> -->
                            </div>
                        </div>
                        <!-- Location -->
                        <!-- Location -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Location :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="locationId"
                                    class="multi-select-list"
                                    multiple
                                    name="locationId"
                                    id="locationId"
                                    label="name"
                                    :filterable="true"
                                    :options="locationArr"
                                    @input="onChnageLocation()"
                                    :clearable="false"
                                    placeholder="Select Location">
                                </v-select>
                                <!-- <div class="requiredstar">*</div>
                                <span class="text-danger">{{locationError}}</span> -->
                            </div>
                        </div>
                        <!-- Timezone -->
                        <!-- <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Timezone :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="timezoneId"
                                    name="timezoneId"
                                    id="timezoneId"
                                    label="text"
                                    :filterable="true"
                                    :options="timezoneOptions"
                                    @input="onChnageTimezone()"
                                    placeholder="Select Timezone">
                                </v-select>
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{timezoneError}}</span>
                            </div>
                        </div> -->
                    </div>
                    <!-- Permissions -->
                    <div class="row no-margin checkbox_container">
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Permissions :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <template v-for="(allPermission, index) in allPermissions">
                                    <input :value="allPermission.id" :key="allPermission.id" type="checkbox" name="permission[]" v-model="checkedPermissionAddTime"> {{allPermission.name}}<br>
                                </template>
                            </div>
                        </div>
                    </div>

                    <!-- Error Alert -->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!-- Buttons -->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary my-1 ms-2" v-on:click.prevent="addUpdateUser ()">
                        <input id="addAndContinueBenifitBtn" :disabled="disableButtons.saveAndContinue" type="submit" :value="buttonNames.saveAndContinue" class="btn btn-primary my-1 ms-2" v-on:click.prevent="addUpdateUser (flag='Save and Continue')">
                        <!-- <input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="addUpdateUser ()"></input> -->
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary my-1 ms-2" v-on:click.prevent="buttonBack">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!-- page content -->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    var moment = require('moment-timezone');

    export default {
        name: 'AddUpdateUser',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
        },
        data() {
            return {
                pageTitle : "Add User",

                firstName : '',
                firstNameError : "",
                lastName : '',
                lastNameError : "",
                email : "",
                emailError : "",
                dayforceId : "",
                dayforceIdError :"",

                allPermissions : [],
                checkedPermissions : [],

                roleOptions : [],
                roleError : "",
                selectedRole : "",
                roleId: {id: '0', name: 'Select Role'},

                password : "",
                passwordError : "",
                confirmPassword : "",
                confirmPasswordError : "",

                timezoneOptions : [],
                timezoneError : "",
                selectTimezone : "",
                timezoneId : {
                    'text' : "",
                    'value' : "",
                },

                entityOptions : [],
                entityError : "",
                entityId : {
                    'text' : "",
                    'value' : "",
                },

                payPlanOptions : [],
                payPlanError : "",
                payPlanId : {
                    'text' : "",
                    'value' : "",
                },

                buttonNames : {
                    save : 'Save',
                    saveAndContinue : 'Save And Continue',
                    cancel : 'Cancel'
                },
                disableButtons : {
                    save : false,
                    saveAndContinue : false,
                    cancel : false
                },
                alertClass : '',
                alertMessage : '',
                permissionRendered : false,
                mappedId: "",
                mappedArr: [],
                mappedIdError: "",
                isMappedListShow: false,
                mappedPlaceholder: "Select Cusomter",
                mappedSearch: "Search Cusomter...",
                isEdit: false,
                checkedPermissionAddTime: [],
                isNonVVGDealer: 'NO',
                locationId: "",
                locationArr: [],
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "listuser");
        },
        watch: {
            email: function(email) {
                if(self.isNonVVGDealer == 'NO') {
                    if (email.length > 3) {
                        if (!self.validEmail(self.email)) {
                            self.emailError = 'Please Enter Valid Email';
                        } else {
                            self.checkUserInSSO();
                        }
                    }
                }
            },
            roleId: function(roleId) {
                self.isMappedListShow = false;
                self.mappedPlaceholder = "Select Customer";
                self.mappedSearch = "Search Customer...";
                if (roleId != null || roleId.id) {
                    if(roleId.id == 3) {
                        self.isMappedListShow = true;
                    } else {
                        self.mappedId = "";
                    }
                }
                // if(roleId.id == 2) {
                //     self.mappedSearch = "Search Sales Person...";
                //     self.mappedPlaceholder = "Select Sales Person";
                // }
                if(!self.isEdit) {
                    self.mappedId = "";
                }
            }
        },
        mounted: function () {
            self.isNonVVGDealer = process.env.NON_VVG_DEALER;
            if(self.isNonVVGDealer == 'YES') {
                setTimeout(function() {
                    self.toggelPasswordConfirmPassword();
                }, 500);
            }
            // EventBus.$emit('showHeader', true);
            $("#alertError").hide();
            self.getAllPermissions();

            self.isEdit = false;
            if (typeof(self.$route.params.id) != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                self.isEdit = true;
                self.getUserDetailByUserId();
                self.buttonNames.save = "Update";
                $("#addAndContinueBenifitBtn").hide();
                // $("#addBenifitBtn").val("Update");
                self.pageTitle = "Edit User";
            }

            /* Get Id of checked Permissions  */
            $(document).ready(function() {
                $("#addBenifitBtn").click(function(){
                    var favorite = [];
                    $.each($("input[name='permission[]']:checked"), function(){
                        favorite.push($(this).val());
                    });
                    self.checkedPermissions = favorite;
                });
            });
            self.getAllLocationList();
            self.getAllRoles();
            //self.getTimezone();
        },
        beforeDestroy() {
            // EventBus.$off('all-permissions');
        },
        methods: {
            toggelPasswordConfirmPassword : function () {
                $(".toggle-password").click(function() {
                    $(this).toggleClass("fa-eye fa-eye-slash");
                    var input = $($(this).attr("toggle"));
                    if (input.attr("type") == "password") {
                        input.attr("type", "text");
                    } else {
                        input.attr("type", "password");
                    }
                });
                $(".toggle-password-confirm").click(function() {
                    $(this).toggleClass("fa-eye fa-eye-slash");
                    var input = $($(this).attr("toggle"));
                    if (input.attr("type") == "password") {
                        input.attr("type", "text");
                    } else {
                        input.attr("type", "password");
                    }
                });
            },
            changedValue: function (value) {
                /*console.log(value);*/
            },
            changedValueMappedList: function () {
                self.mappedIdError = "";
            },
            onChnageLocation: function() {
                self.locationError = "";
            },
            onSearchMappedList(search, loading) {
                if (search.length > 1) {
                    loading(true);
                    self.loadMappedListData(loading, search);
                }
            },
            loadMappedListData(loading, search) {
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                    params: {
                        search: search,
                    }
                };
                var url = "/customer/get";
                if (self.roleId != null || self.roleId.id) {
                    if(self.roleId.id == 2) {
                        url = "/salesuser/get";
                    }
                }
                HTTP.get(url, config)
                    .then(function (response) {
                        loading(false);
                        if (response.status == 200) {
                            self.mappedArr = response.data.content;
                        }
                    })
                    .catch(function (error) {
                        loading(false);
                        // self.catchHandler(error);
                    })
            },
            getAllPermissionsss(){
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.get("permission", config)
                    .then(function (data) {
                        //console.log('allPermissions', data)
                        if (data.status == 200) {
                            self.allPermissions = data.data;
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error);
                    })
            },
            checkUserInSSO : function () {
                let path = window.location.pathname;
                let segments = path.split('/');
                let updateFlag = false;
                let userId = 0;

                if (segments[1] === 'update-user') {
                    updateFlag = true;
                    userId = segments[2];
                } else {
                    updateFlag = false;
                }
                var data = {
                    email : self.email,
                    update_flag : updateFlag,
                    user_id : userId,
                }
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.post('user/checkinsso', data, config)
                    .then(function (response) {
                        if (response.status == 200) {
                            if(response.data.message && response.data.message != 'undefined'){
                                self.firstName = response.data.result.content.first_name;
                                self.lastName = response.data.result.content.last_name;
                                self.dayforceId = response.data.result.content.emp_id;
                                self.showSAlert(response.data.message,'success',false);
                            }
                        }
                    })
                    .catch(function (err) {
                        //console.log(err);
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                self.catchHandler(error);
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            showAlertOnSave : function (alertMessage, alertType) {
                if (alertType === "success") {
                    self.alertClass = "alert alert-success";
                } else {
                    self.alertClass = "alert alert-danger";
                }
                self.alertMessage = alertMessage;
                $("#success-alert").fadeTo(3000, 500).slideUp(500, function(){
                    $("#success-alert").slideUp(500);
                });
            },
            buttonBack : function () {
                self.$router.push('/list-user');
            },
            onChangeEntity : function () {
                self.entityError = "";
            },
            onChangePayPlan : function () {
                self.payPlanError = "";
            },
            onChangeRole : function () {
                self.roleError = "";
                for (var i = 0; i < self.allPermissions.length; i++) {
                    if (self.roleId.value == 1) {
                        $("input[name='permission[]']").each(function (index, obj) {
                            if (obj.value == self.allPermissions[i].permission_id) {
                                $("input[value='" + obj.value + "']").prop('checked', true);
                            }
                        });
                    } else {
                        $("input[name='permission[]']").each(function (index, obj) {
                            if (obj.value == self.allPermissions[i].permission_id) {
                                $("input[value='" + obj.value + "']").prop('checked', false);
                            }
                        });
                    }
                }
            },
            clearDataOnSaveAndContinue : function () {
                self.name = '';
                self.checkedPermissions = [];
                self.checkedPermissionAddTime = [];
                self.firstName = "";
                self.lastName = "";
                self.email = "";
                self.dayforceId = "";
                self.roleId = "";
                /* self.roleId = {
                    'text' : "",
                    'value' : "",
                }; */
                self.entityId = {
                    'text' : "",
                    'value' : "",
                };
                /*self.loadLocations();
                self.loadStations();*/
                for (var i = 0; i < self.allPermissions.length; i++) {
                    $("input[name='permission[]']").each(function (index, obj) {
                        if (obj.value == self.allPermissions[i].permission_id) {
                            $("input[value='" + obj.value + "']").prop('checked', false);
                        }
                    });
                }
                self.mappedId = "";
                self.password = "";
                self.confirmPassword = "";
                self.locationId = "";
            },
            onChnageTimezone : function () {
                self.timezoneError = "";
            },
            getTimezone : function () {
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.get('get-timezone', config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.timezoneOptions = response.data.content;
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            getAllRoles : function () {
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.get('role', config)
                    .then(function (response) {
                        //console.log('roles', response)
                        if (response.status == '200') {
                            //alert('here');
                            self.roleOptions= response.data;
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            checkForm: function () {
                var checked = true;
                if (!self.firstName) {
                    self.firstNameError = "First Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.lastName) {
                    self.lastNameError = "Last Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.roleId == null || !self.roleId.id || self.roleId.id == 0) {
                    self.roleError = "Role Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.email) {
                    self.emailError = "Email Required";
                    if (checked) {
                        checked = false;
                    }
                } else if (self.email && !self.validEmail(self.email)) {
                    self.emailError = "Please Enter Valid Email";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.isNonVVGDealer == 'NO') {
                    if (!self.dayforceId) {
                        self.dayforceIdError = "DayforceId Required";
                        if (checked) {
                            checked = false;
                        }
                    }
                } else {
                    if (typeof(self.$route.params.id) != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                        if (self.password && !self.confirmPassword) {
                            self.confirmPasswordError = "Confirm Password Required";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.confirmPassword && !self.password) {
                            self.passwordError = "Password Required";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.confirmPassword && !self.checkPasswordAndConfirmPassword(self.password, self.confirmPassword)) {
                            self.confirmPasswordError = "Password and Confirm Password do not match";
                            if (checked) {
                                checked = false;
                            }
                        }
                    } else {
                        if (!self.password) {
                            self.passwordError = "Password Required";
                            if (checked) {
                                checked = false;
                            }
                        }
                        if (self.password && !self.confirmPassword) {
                            self.confirmPasswordError = "Confirm Password Required";
                            if (checked) {
                                checked = false;
                            }
                        } else if (self.confirmPassword && !self.checkPasswordAndConfirmPassword(self.password, self.confirmPassword)) {
                            self.confirmPasswordError = "Password and Confirm Password do not match";
                            if (checked) {
                                checked = false;
                            }
                        }
                    }
                }
                /* if (self.timezoneId == null || !self.timezoneId.value) {
                    self.timezoneError = "Timezone Required";
                    if (checked) {
                        checked = false;
                    }
                } */
                /* if(self.isMappedListShow && self.mappedId.length == 0) {
                    self.mappedIdError = "Mapped List Required";
                    if (checked) {
                        checked = false;
                    }
                } */
                return checked;
            },
            checkPasswordAndConfirmPassword : function (password, confirmPassword) {
                if (password != confirmPassword) {
                    return false;
                } else {
                    return true;
                }
            },
            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            getUserDetailByUserId: function () {
                var path = window.location.pathname;
                var segments = path.split("/");
                var fields = {
                    user_id: segments[2],
                };
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.post('/user/get-detail-by-user-id', fields, config)
                    .then(response => {
                        self.firstName = response.data.user.first_name;
                        self.lastName = response.data.user.last_name;
                        self.email = response.data.user.username;
                        self.dayforceId = response.data.user.emp_id;
                        if (response.data.user.roles[0] != null) {
                            self.roleId = {
                                'name' : self.formatString(response.data.user.roles[0].name),
                                'id' : response.data.user.roles[0].id,
                            };
                        }
                        self.checkedPermissions = [];
                        self.$nextTick(() => {
                            if (response.data.user.permissions.length > 0) {
                                for (var i = 0; i < response.data.user.permissions.length; i++) {
                                    self.checkedPermissions.push(response.data.user.permissions[i].id);
                                    $("input[name='permission[]']").each(function (index, obj) {
                                        if (obj.value == response.data.user.permissions[i].id) {
                                            $("input[value='" + obj.value + "']").prop('checked', true);
                                        }
                                    });
                                }
                            }
                        });
                        self.mappedId = [];
                        if(response.data.mapped_list && response.data.mapped_list.length > 0) {
                            for (var i = 0; i < response.data.mapped_list.length; i++) {
                                self.mappedId.push({'text': response.data.mapped_list[i].name, 'value': response.data.mapped_list[i].id});
                            }
                        }
                        self.locationId = [];
                        if(response.data.location && response.data.location.length > 0) {
                            for (var i = 0; i < response.data.location.length; i++) {
                                self.locationId.push({'name': response.data.location[i].name, 'id': response.data.location[i].id});
                            }
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            //self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //self.$router.push("/login");
                            }
                            //self.error = err.response.data.message;
                        }
                    });
            },
            addUpdateUser (flag) {
                setTimeout(() => {
                    if (self.checkForm()) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        var config = {
                            headers: {Authorization:localStorage.getItem("access_token")},
                        };

                        var mapped_id = '';
                        if( self.mappedId && self.mappedId.length > 0 ) {
                            for (var i = 0; i < self.mappedId.length; i++) {
                                mapped_id += (self.mappedId[i].value) + ',';
                            }
                            mapped_id = mapped_id.replace(/,\s*$/, "");
                        }
                        var locationsIdValue = '';
                        if( self.locationId && self.locationId.length > 0 ) {
                            for (var i = 0; i < self.locationId.length; i++) {
                                locationsIdValue += (self.locationId[i].id) + ',';
                            }
                            locationsIdValue = locationsIdValue.replace(/,\s*$/, "");
                        }

                        if (typeof(self.$route.params.id) != 'undefined' && self.$route.params.id != 0 && self.$route.params.id != '') {
                            if(self.isNonVVGDealer == 'NO') {
                                var data = {
                                    first_name: self.firstName,
                                    last_name: self.lastName,
                                    email: self.email,
                                    permission_id: self.checkedPermissions,
                                    role_id : self.roleId.id,
                                    entity_id : self.entityId.value,
                                    payplan_id : self.payPlanId.value,
                                    dayforce_id : self.dayforceId,
                                    timezone_id : self.timezoneId.value,
                                    mapped_list: mapped_id,
                                    id: segments[2],
                                    is_non_vvg_dealer: self.isNonVVGDealer,
                                    location_id: locationsIdValue
                                };
                            } else {
                                var data = {
                                    first_name: self.firstName,
                                    last_name: self.lastName,
                                    email: self.email,
                                    permission_id: self.checkedPermissions,
                                    role_id : self.roleId.id,
                                    entity_id : self.entityId.value,
                                    payplan_id : self.payPlanId.value,
                                    password : self.password,
                                    timezone_id : self.timezoneId.value,
                                    mapped_list: mapped_id,
                                    id: segments[2],
                                    is_non_vvg_dealer: self.isNonVVGDealer,
                                    location_id: locationsIdValue
                                };
                            }
                            self.buttonNames.save = "Updating ...";
                            self.disableButtons.save = true;
                            self.disableButtons.cancel = true;
                        } else {
                            if(self.isNonVVGDealer == 'NO') {
                                var data = {
                                    first_name: self.firstName,
                                    last_name: self.lastName,
                                    email: self.email,
                                    permission_id: self.checkedPermissionAddTime,
                                    role_id : self.roleId.id,
                                    entity_id : self.entityId.value,
                                    payplan_id : self.payPlanId.value,
                                    dayforce_id : self.dayforceId,
                                    timezone_id : self.timezoneId.value,
                                    mapped_list: mapped_id,
                                    is_non_vvg_dealer: self.isNonVVGDealer,
                                    location_id: locationsIdValue
                                };
                            } else {
                                var data = {
                                    first_name: self.firstName,
                                    last_name: self.lastName,
                                    email: self.email,
                                    permission_id: self.checkedPermissionAddTime,
                                    role_id : self.roleId.id,
                                    entity_id : self.entityId.value,
                                    payplan_id : self.payPlanId.value,
                                    password : self.password,
                                    timezone_id : self.timezoneId.value,
                                    mapped_list: mapped_id,
                                    is_non_vvg_dealer: self.isNonVVGDealer,
                                    location_id: locationsIdValue
                                };
                            }
                            if (flag == "Save and Continue") {
                                self.buttonNames.saveAndContinue = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true
                            } else {
                                self.buttonNames.save = "Saving ...";
                                self.disableButtons.save = true;
                                self.disableButtons.saveAndContinue = true;
                                self.disableButtons.cancel = true;
                            }
                        }
                        HTTP.post("/user/add", data, config)
                            .then(function (response) {
                                EventBus.$emit('change_sidebar_menu', false, response.data.content);
                                if (segments[1] == 'update-user') {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    if (segments[2]) {
                                        self.buttonNames.save = "Update";
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                        } else {
                                            self.buttonNames.save = "Save";
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                    } else {
                                        self.buttonNames.save = "Save";
                                    }
                                }
                                //console.log('user/add', response)
                                if (response.data.status == "success") {
                                    self.disableButtons.save = true;
                                    self.disableButtons.saveAndContinue = true;
                                    self.disableButtons.cancel = true;
                                    EventBus.$emit('succes-message', response.data.user_message);
                                    //self.showAlertOnSave(response.data.user_message, "success");
                                    self.showSAlert(response.data.user_message,'success',false);
                                    if (flag == "Save and Continue") {
                                        self.clearDataOnSaveAndContinue();
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                    } else {
                                        setTimeout(function () {
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            self.buttonBack();
                                        }, 3000);
                                    }
                                    self.getUserPermissions();
                                } else {
                                    self.disableButtons.save = false;
                                    self.disableButtons.saveAndContinue = false;
                                    self.disableButtons.cancel = false;
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < response.data.content.length; i++) {
                                            err += response.data.content[i];
                                        }
                                        EventBus.$emit('succes-message', err);
                                        self.showAlertOnSave(err, "error");
                                    }
                                }
                            })
                            .catch(function (err) {
                                if (segments[1] == 'update-user') {
                                    if (segments[2]) {
                                        self.buttonNames = "Update";
                                        self.disableButtons.save = false;
                                        self.disableButtons.cancel = false;
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    } else {
                                        if (flag == "Save and Continue") {
                                            self.buttonNames.saveAndContinue = "Save and Continue";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                            self.clearDataOnSaveAndContinue();
                                        } else {
                                            self.buttonNames.save = "Save";
                                            self.disableButtons.save = false;
                                            self.disableButtons.saveAndContinue = false;
                                            self.disableButtons.cancel = false;
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }

                                        if (err.response.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (err.response.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                localStorage.removeItem("profile_image");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            EventBus.$emit('succes-message', err.response.data.message);
                                            //self.showAlertOnSave(err.response.data.message, "error");
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        self.buttonNames.saveAndContinue = "Save and Continue";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                        self.clearDataOnSaveAndContinue();
                                    } else {
                                        self.buttonNames.save = "Save";
                                        self.disableButtons.save = false;
                                        self.disableButtons.saveAndContinue = false;
                                        self.disableButtons.cancel = false;
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }

                                    if (err.response.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        EventBus.$emit('succes-message', err.response.data.message);
                                        //self.showAlertOnSave(err.response.data.message, "error");
                                    }
                                }
                            });
                    }
                }, 200);
            },
        }
    }
    EventBus.$on('all-location-list', function (response) {
        if (typeof (self) != 'undefined') {
            self.locationArr = response;
        }
    });
    EventBus.$on('all-permissions', function (isLogin, allPermissions) {
        if (typeof (self) != 'undefined') {
            self.allPermissions = [];
            for (var i = 0; i < allPermissions.length; i++) {
                if(self.isNonVVGDealer == 'YES') {
                    if(
                        allPermissions[i].id != '5'
                        && allPermissions[i].id != '7'
                        && allPermissions[i].id != '8'
                        && allPermissions[i].id != '9'
                        && allPermissions[i].id != '10'
                        && allPermissions[i].id != '11'
                    ) {
                    } else {
                        continue;
                    }
                }
                var permissionNameArray = allPermissions[i].name.split("_");
                var permissionName = '';
                var permission = '';

                for (var j = 0; j < permissionNameArray.length; j++) {
                    permission = permissionNameArray[j].charAt(0).toUpperCase() + permissionNameArray[j].slice(1);
                    permissionName = permissionName +  " " + permission;
                }

                self.allPermissions.push({
                    'id' : allPermissions[i].id,
                    'name' : permissionName
                });
            }

            let path = window.location.pathname;
            let segments = path.split('/');

            if (segments[1] === 'update-user') {
                self.getUserDetailByUserId();
            }
            // self.allPermissions = allPermissions;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/User/AddUpdateUser.vue